module.exports = __webpack_public_path__ + "img/credit-card.e16ca649.svg";